
import { createContext, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import IdGenerator from '../../utils/IdGenerator';
import CapabilityProvider from '../CapabilityProvider';
import { elementsVersion, styleGuideUrl } from './Provider.types';

export const THEME = {
  neutral: '',
  ergodirekt: 'ergodirekt',
  ergo: 'ergo',
  das: 'das',
  dkv: 'dkv',
  'ergo-one': 'ergo-one',
};

export const ErgoElementsContext = createContext({
  idGenerator: new IdGenerator('implicit_context'),
  theme: '',
});

const Provider = ({
  theme = THEME.neutral,
  contextName,
  idGenerator,
  children,
  capabilities = [],
  className,
  ...other
}) => {
  const generator = useMemo(
    () => idGenerator || new IdGenerator(contextName),
    [idGenerator, contextName]
  );

  useEffect(() => {
    if (theme === THEME['ergo-one']) {
      console.warn(
        'Das theme ERGO ONE ist noch experimentell und sollte nicht produktiv verwendet werden!'
      );
    }

    if (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test') {
      if (styleGuideUrl) {
        console.info(
          `Wir haben bemerkt, dass du ERGO Elements benutzt. Falls du Hilfe brauchst klicke hier: ${styleGuideUrl}`
        );
      }
    }
  }, [theme]);

  const contextValue = { idGenerator: generator, theme };

  return (
    <div
      {...other}
      className={className}
      data-theme={theme}
      data-version={elementsVersion}
      data-root="true"
    >
      <ErgoElementsContext.Provider value={contextValue}>
        <CapabilityProvider capabilities={capabilities}>{children}</CapabilityProvider>
      </ErgoElementsContext.Provider>
    </div>
  );
};

Provider.propTypes = {
  theme: PropTypes.oneOf(['', 'ergo', 'ergo-one', 'ergodirekt', 'das', 'dkv']),
  contextName: PropTypes.string,
  idGenerator: PropTypes.shape({
    next: PropTypes.func.isRequired,
  }),
  children: PropTypes.node.isRequired,
  capabilities: PropTypes.arrayOf(PropTypes.element),
  className: PropTypes.string,
};

export default Provider;
